const SUPPORTED_LOCALES = ['it', 'en', 'fr', 'de'];

export const repMetricLocale = language => {
  const locale = String(language || '').split('-')[0].toLowerCase();
  return SUPPORTED_LOCALES.includes(locale) ? locale : 'it';
};

export const repWhisperLanguage = language => {
  const locale = String(language || '').split('-')[0].toLowerCase();
  return SUPPORTED_LOCALES.includes(locale) ? locale : 'auto';
};

export const buildLocalRepMetric = ({outcome, intent, locale, channel = 'text', durationMs = null, errorCode = null}) => ({
  eventType: 'assistant_query',
  channel,
  outcome,
  intent: intent || null,
  locale: repMetricLocale(locale),
  provider: 'local_parser',
  statusCode: outcome === 'error' ? 500 : 200,
  errorCode: errorCode || null,
  durationMs: durationMs === null ? null : Math.max(0, Math.min(Math.round(durationMs), 120000))
});
